var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-popup",
    {
      staticClass: "newsletter-popup",
      attrs: {
        fullscreen: "",
        active: _vm.isVisible,
        title: _vm.$t("newsletter.title")
      },
      on: {
        "update:active": function($event) {
          _vm.isVisible = $event
        },
        close: _vm.onClose
      }
    },
    [
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_name: "newsletters",
          order_column: "created_at",
          direction: "desc",
          hide_actions: "true"
        },
        scopedSlots: _vm._u([
          {
            key: "filterZone",
            fn: function() {
              return [
                _c("div", { staticClass: "grid grid-cols-2 gap-2 pt-2" }, [
                  _c(
                    "div",
                    [
                      _c("select-suggestion", {
                        key: _vm.groupNewsKey,
                        staticClass: "required",
                        attrs: {
                          column: "name",
                          model: "GroupNews",
                          label: _vm.$t("group_news.group"),
                          appendClearOption: true,
                          placeholderText: "Digite o nome do grupo"
                        },
                        on: {
                          clearSelection: _vm.clearSubgroupNews,
                          "selected-model": _vm.clearSubgroupNews
                        },
                        model: {
                          value: _vm.selectedGroupNews,
                          callback: function($$v) {
                            _vm.selectedGroupNews = $$v
                          },
                          expression: "selectedGroupNews"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("select-suggestion", {
                        key: _vm.subgroupNewsKey,
                        staticClass: "required",
                        attrs: {
                          column: "name",
                          model: "SubgroupNews",
                          label: _vm.$t("subgroup_news.subgroup"),
                          appendClearOption: true,
                          placeholderText: "Digite o nome do subgrupo",
                          disabled: !_vm.enableSubgroupNews,
                          extraParamsFilters: {
                            group_news_id: _vm.selectedGroupNews
                              ? _vm.selectedGroupNews.id
                              : null
                          }
                        },
                        model: {
                          value: _vm.selectedSubgroupNews,
                          callback: function($$v) {
                            _vm.selectedSubgroupNews = $$v
                          },
                          expression: "selectedSubgroupNews"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "gridThead",
            fn: function() {
              return [
                _c(
                  "vs-th",
                  {
                    key: "checkbox",
                    attrs: { width: "5%", "disable-sort": "" }
                  },
                  [
                    _c("b-form-checkbox", {
                      on: { input: _vm.handleSelectAllInput },
                      model: {
                        value: _vm.selectAllChecked,
                        callback: function($$v) {
                          _vm.selectAllChecked = $$v
                        },
                        expression: "selectAllChecked"
                      }
                    })
                  ],
                  1
                ),
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID")
                ]),
                _c("vs-th", { key: "title", attrs: { "sort-key": "title" } }, [
                  _vm._v(_vm._s(_vm.$t("newsletter.title")))
                ]),
                _c(
                  "vs-th",
                  {
                    key: "group_news_name",
                    attrs: { "sort-key": "group_news_name" }
                  },
                  [_vm._v(_vm._s(_vm.$t("group_news.group")))]
                ),
                _c(
                  "vs-th",
                  {
                    key: "subgroup_news_name",
                    attrs: { "sort-key": "subgroup_news_name" }
                  },
                  [_vm._v(_vm._s(_vm.$t("subgroup_news.subgroup")))]
                ),
                _c(
                  "vs-th",
                  { key: "status", attrs: { "sort-key": "status" } },
                  [_vm._v(_vm._s(_vm.$t("newsletter.status")))]
                )
              ]
            },
            proxy: true
          },
          {
            key: "gridData",
            fn: function(props) {
              return _vm._l(props.data, function(tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c(
                      "vs-td",
                      { key: "checkbox", attrs: { width: "5%" } },
                      [
                        _c("b-form-checkbox", {
                          attrs: { value: tr },
                          on: {
                            change: function($event) {
                              return _vm.toggleItemSelection(tr)
                            }
                          },
                          model: {
                            value: _vm.selectedList,
                            callback: function($$v) {
                              _vm.selectedList = $$v
                            },
                            expression: "selectedList"
                          }
                        })
                      ],
                      1
                    ),
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.id) + " ")])
                    ]),
                    _c("vs-td", { key: "title", attrs: { width: "20%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.title))])
                    ]),
                    _c(
                      "vs-td",
                      { key: "group_news_name", attrs: { width: "20%" } },
                      [_c("div", [_vm._v(" " + _vm._s(tr.group_news_name))])]
                    ),
                    _c(
                      "vs-td",
                      { key: "subgroup_news_name", attrs: { width: "20%" } },
                      [_c("div", [_vm._v(" " + _vm._s(tr.subgroup_news_name))])]
                    ),
                    _c("vs-td", { key: "status", attrs: { width: "15%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.status_fmt))])
                    ])
                  ],
                  1
                )
              })
            }
          }
        ])
      }),
      _c(
        "div",
        { staticClass: "flex justify-end gap-2 mt-4" },
        [
          _c(
            "b-button",
            {
              attrs: {
                variant: "primary",
                disabled: _vm.selectedList.length === 0
              },
              on: { click: _vm.onAddSelected }
            },
            [
              _vm._v(
                " (" +
                  _vm._s(_vm.selectedList.length) +
                  ") " +
                  _vm._s(_vm.$t("action.add")) +
                  " "
              )
            ]
          ),
          _c(
            "b-button",
            { attrs: { variant: "secondary" }, on: { click: _vm.onClose } },
            [_vm._v(" " + _vm._s(_vm.$t("action.cancel")) + " ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }